import { environment } from 'environments/environment';

const Prefix = {
  Identity: `${environment.service.host}/identity`,
  Master: `${environment.service.host}/master`,
  Configuration: `${environment.service.host}/configuration`,
  Customer: `${environment.service.host}/customer`,
  Transaction:
    environment.mode !== 'local'
      ? `${environment.service.host}/order`
      : 'https://apigw-dev.xbaht.com/order',
  Logger: `${environment.service.host}/logger`,
};

export const Endpoint = {
  Identity: {
    Authentication: {
      SignIn: `${Prefix.Identity}/authentication/sign-in`,
      AuthenticatorKey: `${Prefix.Identity}/authentication/authenticator-key`,
      AuthenticatorCode: `${Prefix.Identity}/authentication/authenticator-code`,
      Verify: `${Prefix.Identity}/authentication/verify`,
      Token: `${Prefix.Identity}/authentication/token`,
      Permission: `${Prefix.Identity}/authentication/permission`,
      ForgotPassword: `${Prefix.Identity}/authentication/forgot-password`,
      ResetPassword: `${Prefix.Identity}/authentication/reset-password`,
      VerifyAuthenticator: `${Prefix.Identity}/authentication/authenticator-reactivate/verify`,
      ActivateAuthenticator: `${Prefix.Identity}/authentication/authenticator-reactivate/activate`,
      SignOut: `${Prefix.Identity}/authentication/sign-out`,
    },
    User: {
      Common: `${Prefix.Identity}/user`,
    },
    Role: {
      Common: `${Prefix.Identity}/role`,
      Compact: `${Prefix.Identity}/role/compact`,
    },
    History: {
      Common: `${Prefix.Identity}/history`,
    },
  },
  Master: {
    Claim: {
      Common: `${Prefix.Master}/claim`,
    },
    Country: {
      Common: `${Prefix.Master}/country`,
      Old: `${Prefix.Master}/country/old`,
    },
    Currency: {
      Common: `${Prefix.Master}/currency`,
      Old: `${Prefix.Master}/currency/old`,
    },
    PayoutMethod: {
      Common: `${Prefix.Master}/payout-method`,
    },
    Partner: {
      Common: `${Prefix.Master}/partner`,
    },
    Expression: {
      Common: `${Prefix.Master}/expression`,
    },
    PaymentMethod: {
      Common: `${Prefix.Master}/payment-method`,
    },
    RiskLevel: {
      Common: `${Prefix.Master}/risk-level`,
    },
    //   Occupation: {
    //     Common: `${Prefix.Master}/occupation`,
    //   },
    //   MonthlyPayment: {
    //     Common: `${Prefix.Master}/monthlypayment`,
    //   },
    //   Purpose: {
    //     Common: `${Prefix.Master}/purpose`,
    //   },
    //   Regularity: {
    //     Common: `${Prefix.Master}/regularity`,
    //   },
    CustomerTag: {
      Common: `${Prefix.Master}/customer-tag`,
    },
    Bank: {
      Common: `${Prefix.Master}/bank`,
    },
    Branch: {
      Common: `${Prefix.Master}/branch`,
    },
    UpdateRequest: {
      Common: `${Prefix.Master}/update-request`,
    },
    TimeRequest: {
      Common: `${Prefix.Master}/time-request`,
    },
    DocumentRequest: {
      Common: `${Prefix.Master}/document-request`,
    },
  },
  Configuration: {
    Country: {
      Common: `${Prefix.Configuration}/country`,
      // History: `${Prefix.Configuration}/country/history`,
    },
    ExchangeRate: {
      Common: `${Prefix.Configuration}/exchange-rate`,
      Live: `${Prefix.Configuration}/exchange-rate/live`,
      // History: `${Prefix.Configuration}/exchangerate/history`,
    },
    TransactionFee: {
      Common: `${Prefix.Configuration}/transaction-fee`,
      // History: `${Prefix.Configuration}/transaction-fee/history`,
    },
    SystemLimit: {
      Common: `${Prefix.Configuration}/system-limit`,
      // History: `${Prefix.Configuration}/systemlimit/history`,
    },
    PayoutPartner: {
      Common: `${Prefix.Configuration}/payout-partner`,
      // History: `${Prefix.Configuration}/payoutpartner/history`,
    },
    Campaign: {
      Common: `${Prefix.Configuration}/campaign`,
      // History: `${Prefix.Configuration}/campaign/history`,
    },
    Application: {
      Common: `${Prefix.Configuration}/application`,
      // History: `${Prefix.Configuration}/application/history`,
    },
    Notification: {
      Common: `${Prefix.Configuration}/notification`,
      // History: `${Prefix.Configuration}/notification/history`,
    },
  },
  Transaction: {
    Order: {
      Common: `${Prefix.Transaction}`,
      Orders: `${Prefix.Transaction}/orders`,
      PayIn: `${Prefix.Transaction}/{orderNo}/payins`,
      PayOut: `${Prefix.Transaction}/{orderNo}/payouts`,
      Customer: `${Prefix.Transaction}/customer`,
      Export: `${Prefix.Transaction}/export`,
      Resend: `${Prefix.Transaction}/resend`,
      Verify: `${Prefix.Transaction}/verify`,
      Refund: `${Prefix.Transaction}/refund`,
      History: `${Prefix.Transaction}/history`,
    },
  },
  Customer: {
    Customer: {
      Common: `${Prefix.Customer}/customer`,
      Export: `${Prefix.Customer}/customer/export`,
      // History: `${Prefix.Customer}/customer/history`,
    },
    Recipient: {
      Common: `${Prefix.Customer}/recipient`,
      // History: `${Prefix.Customer}/recipient/history`,
    },
    // ComplianceKyc: {
    //   Common: `${Prefix.Customer}/compliance-kyc`,
    //   Document: `${Prefix.Customer}/compliance-kyc/document`,
    //   History: `${Prefix.Customer}/compliance-kyc/history`,
    // },
    Compliance: {
      Common: `${Prefix.Customer}/compliance`,
      Cancel: `${Prefix.Customer}/compliance/cancel`,
      Upload: `${Prefix.Customer}/compliance/upload`,
    },
    ComplianceRequest: {
      Common: `${Prefix.Customer}/compliance-request`,
    },
    ComplianceInformation: {
      Common: `${Prefix.Customer}/compliance-information`,
    },
    ComplianceDocument: {
      Common: `${Prefix.Customer}/compliance-document`,
      Group: `${Prefix.Customer}/compliance-document/group`,
    },
    ComplianceRedFlag: {
      Common: `${Prefix.Customer}/compliance-red-flag`,
      Group: `${Prefix.Customer}/compliance-red-flag/group`,
      // History: `${Prefix.Customer}/compliance-red-flag/history`,
    },
    DocumentNote: {
      Common: `${Prefix.Customer}/document-note`,
    },
    Metabase: {
      Dataset: `${Prefix.Customer}/metabase/dataset`,
    },
  },
  Logger: {
    History: {
      Common: `${Prefix.Logger}/history`,
    },
  },
};
